import React from 'react';
import { Grid, Typography } from '@mui/material';
import ResponsiveGrid from 'mui/components/elements/DS_Grid';
import DS_ButtonLink from 'mui/components/elements/DS_ButtonLink';
import DS_LabelTag from 'mui/components/elements/DS_LabelTag';
import { DS_spacing as coreSpacing } from 'mui/base/theme/DS_Tokens/core';
import RichText from '../RichText/RichText';
import { StyledHeader, StyledButtonWrapper, StyledDescription, StyledRichDescription } from './DS_HeaderStyles';

const DS_Header = ({
  labelTagIcon,
  labelTag,
  headline,
  headlineVariant = 'h2',
  leadText,
  isLabel,
  link,
  leadTextRt,
  richTextMarkOverrides = {},
  richTextNodeOverrides = {},
}) => {
  return (
    <StyledHeader>
      <ResponsiveGrid marginBottom={coreSpacing['rem']['xxl']}>
        <Grid item xs={12} lg={8}>
          {labelTag ? <DS_LabelTag text={labelTag} isLabel={isLabel} icon={labelTagIcon} /> : null}
          {headline ? (
            <Typography variant="DS_h2" component={headlineVariant === 'h1' ? 'h1' : 'h2'}>
              {headline}
            </Typography>
          ) : null}
          {leadText ? (
            <StyledDescription variant="DS_copyBigRegular" component="p">
              {leadText}
            </StyledDescription>
          ) : null}
          {leadTextRt ? (
            <StyledRichDescription>
              <RichText
                document={leadTextRt}
                renderMarkOverrides={richTextMarkOverrides}
                renderNodeOverrides={richTextNodeOverrides}
              />
            </StyledRichDescription>
          ) : null}
        </Grid>
        <Grid item xs={12} lg={4}>
          {link?.url ? (
            <StyledButtonWrapper>
              <DS_ButtonLink {...link} url={link.url} isSizeBig={true} />
            </StyledButtonWrapper>
          ) : null}
        </Grid>
      </ResponsiveGrid>
    </StyledHeader>
  );
};

export default DS_Header;
